import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface CourseState {
  sidebarActiveTab: string | null
  headerString: string | null
  courseId: string | null
  moduleId: string | null
  userTopicId: string | null
  exerciseCategory: string | null
  testConfig: any | null
  courseClient: string
}

const initialState: CourseState = {
  sidebarActiveTab: null,
  headerString: null,
  courseId: null,
  moduleId: null,
  userTopicId: null,
  exerciseCategory: null,
  testConfig: {},
  courseClient: "",
}

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    setSidebarActiveTab: (state, action: PayloadAction<any>) => {
      state.sidebarActiveTab = action.payload
    },
    setHeaderString: (state, action: PayloadAction<any>) => {
      state.headerString = action.payload
    },
    setCourseId: (state, action: PayloadAction<string | null>) => {
      state.courseId = action.payload
    },
    setModuleId: (state, action: PayloadAction<string | null>) => {
      state.moduleId = action.payload
    },
    setUserTopicId: (state, action: PayloadAction<string | null>) => {
      state.userTopicId = action.payload
    },
    setExerciseCategory: (state, action: PayloadAction<string | null>) => {
      state.exerciseCategory = action.payload
    },
    setTestConfig: (state, action: PayloadAction<any | null>) => {
      state.testConfig = action.payload
    },
    setCourseClient: (state, action: PayloadAction<string>) => {
      state.courseClient = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  setSidebarActiveTab,
  setHeaderString,
  setCourseId,
  setModuleId,
  setUserTopicId,
  setExerciseCategory,
  resetState,
  setTestConfig,
  setCourseClient,
} = courseSlice.actions
export default courseSlice.reducer
